import React from "react";
import Parser from "../../parser";
const IconGrid = (props) => {
    const classNames = ((attributes) => {
        let className = ["icon-grid"];
        if (attributes.align === "full") {
            className.push("alignfull");
        }
        if (attributes.backgroundColor) {
            className.push("has-" + attributes.backgroundColor + "-background-color");
        }
        if (attributes.className) {
            className.push(attributes.className);
        }
        return className.join(" ");
    })(props.attributes);
    return (React.createElement("div", { className: classNames },
        React.createElement(Parser, { structure: props.innerBlocks })));
};
export default IconGrid;
